import React, { useState } from "react";
import { MessageSquare, Phone, MapPin, Send } from "lucide-react";
import emailjs from "@emailjs/browser";
import "./ContactUs.css";

const ContactUs = () => {
  const [activeTab, setActiveTab] = useState("message");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_niod435",
        "template_opfzeih",
        formData,
        "iOB3PqY2XOUqH_NDP"
      )
      .then(
        (result) => {
          console.log("SUCCESS!", result.text);
          alert("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          console.error("FAILED...", error.text);
          alert("Message failed to send.");
        }
      );
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h2>
            Contact Our <span>Technical Team</span>
          </h2>
          <p>Get in touch with our solutions experts</p>
        </div>

        <div className="contact-grid">
          <div className="contact-panel">
            <div className="tab-buttons">
              <button
                className={`tab-btn ${activeTab === "message" ? "active" : ""}`}
                onClick={() => setActiveTab("message")}
              >
                <MessageSquare size={18} />
                Message
              </button>
              <button
                className={`tab-btn ${activeTab === "call" ? "active" : ""}`}
                onClick={() => setActiveTab("call")}
              >
                <Phone size={18} />
                Contact
              </button>
              <button
                className={`tab-btn ${
                  activeTab === "location" ? "active" : ""
                }`}
                onClick={() => setActiveTab("location")}
              >
                <MapPin size={18} />
                Location
              </button>
            </div>

            {activeTab === "message" && (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="input-group">
                  <label>Your Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Full name"
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="input-group">
                  <label>Your Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="How can we assist you?"
                    rows={5}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  <Send size={18} />
                  Send Message
                </button>
              </form>
            )}

            {activeTab === "call" && (
              <div className="contact-info">
                <div className="info-item">
                  <h3>Email</h3>
                  <a href="mailto:info@katrori-its.com">info@katrori-its.com</a>
                </div>
                <div className="info-item">
                  <h3>Phone</h3>
                  <a href="tel:+38349123456">+383(0) 38 606 806</a>
                </div>
                <div className="info-item">
                  <h3>Hours</h3>
                  <p>Monday - Friday: 8:00 - 16:00</p>
                </div>
              </div>
            )}

            {activeTab === "location" && (
              <div className="location-info">
                <div className="address">
                  <h3>Headquarters</h3>
                  <p>Katrori ITS</p>
                  <p>Magjistralja Prishtine-Shkup 10KM</p>
                  <p>Lipjan 10000</p>
                </div>
                <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2812.334503004176!2d21.125192075803557!3d42.56373092221039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549f2060d29b0b%3A0x6b3d0fd0846f70c4!2sKatrori%20ITS!5e1!3m2!1sen!2s!4v1750835455281!5m2!1sen!2s"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
